<div class="xgrid-debug">
  <div
    class="area area-details"
    idealNavAnchor="app.main-menu/products/details/"
    [navHidden]="false"
    navLabel="Details"
    navHeading="Product"
    i18n-navLabel="@@products.details.label"
    i18n-navHeading="@@products.nav.product.heading"
  ></div>
  <div class="area area-header" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Header]" (heightChange)="headerHeight.set($event)">
    <ideal-render-target-product-details-header />
  </div>

  <div class="area area-main-card">
    <div class="area col area-main-card-col-1">
      <div class="area area-main-card-float">
        <div class="area area-images" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Images]">
          <ideal-render-target-product-details-images />
        </div>
        @if (componentWidth() > ComponentLayoutSize.Medium) {
          <!-- The vendor shop link comes first, right under the product image. -->
          <div class="area area-vendor" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Vendor]">
            <ideal-render-target-product-details-vendor />
          </div>
          <div class="area area-badges" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Badges]">
            <ideal-render-target-product-details-badges />
          </div>
        }
      </div>
    </div>
    <div class="area col area-main-card-col-2">
      @if (hasInfo()) {
        <div class="area area-important-info">
          <ideal-render-target-product-details-title *ifHasRenderInSources="LayoutComponents[LayoutTargets.Title]" />
          <ideal-render-target-product-details-important-info *ifHasRenderInSources="LayoutComponents[LayoutTargets.ImportantInfo]" />
        </div>
      }
      @if (componentWidth() > ComponentLayoutSize.Medium) {
        <div class="area area-actions">
          <ideal-render-target-product-details-actions *ifHasRenderInSources="LayoutComponents[LayoutTargets.Actions]" />
        </div>
      } @else {
        <!-- The vendor shop link comes first, right under the product image. -->
        <div class="area area-vendor" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Vendor]">
          <ideal-render-target-product-details-vendor />
        </div>
        <div class="area area-badges" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Badges]">
          <ideal-render-target-product-details-badges />
        </div>
      }
    </div>
    @if (componentWidth() <= ComponentLayoutSize.Medium) {
      <div class="area area-actions">
        <ideal-render-target-product-details-actions *ifHasRenderInSources="LayoutComponents[LayoutTargets.Actions]" />
      </div>
    }
  </div>

  <div class="area area-default">
    <div class="area area-extra-actions">
      <ideal-render-target-product-details-extra-actions *ifHasRenderInSources="LayoutComponents[LayoutTargets.ExtraActions]" />
    </div>
    <ideal-product-section
      long-description
      i18n-title="@@products.longDescription.label"
      title="Description"
      navAnchorId="app.main-menu/products/details/description"
      navAnchorHeading="Product"
      i18n-navAnchorHeading="@@products.nav.product.heading"
      [navAnchorHidden]="!ready()"
      class="padded"
      *ifHasRenderInSources="LayoutComponents[LayoutTargets.LongDescription]"
    >
      <ideal-render-target-product-details-long-description></ideal-render-target-product-details-long-description>
    </ideal-product-section>
    <ideal-render-target-product-details-default
      *ifHasRenderInSources="LayoutComponents[LayoutTargets.Default]"
    ></ideal-render-target-product-details-default>
  </div>
  <div class="area area-footer" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Header]">
    <ideal-render-target-product-details-header></ideal-render-target-product-details-header>
  </div>
</div>

@if (typeComponentInjector() && productTypeComponents()) {
  <div style="display: none">
    @for (component of productTypeComponents(); track $index) {
      <ng-container *ngComponentOutlet="component; injector: typeComponentInjector(); inputs: componentInputs()"></ng-container>
    }
  </div>
}

<!--




<div header *ifHasRenderInSources="LayoutComponents[LayoutTargets.Header]">
  <ideal-render-target-product-details-header></ideal-render-target-product-details-header>
</div>


<div layout-container>
  <div
    details-area
    idealNavAnchor="app.main-menu/products/details/"
    [navHidden]="false"
    navLabel="Details"
    navHeading="Product"
    i18n-navLabel="@@products.details.label"
    i18n-navHeading="@@products.nav.product.heading"
  ></div>
  <div actions-area></div>
  <div image-col>
    <div image>
      <ideal-render-target-product-details-images></ideal-render-target-product-details-images>
    </div>
  </div>
  <div main-col>
    @if (componentWidth() <= ComponentLayoutSize.Medium) {
      <div title>
        <ideal-render-target-product-details-title></ideal-render-target-product-details-title>
      </div>
    }
    <div important-info *ifHasRenderInSources="LayoutComponents[LayoutTargets.ImportantInfo]">
      <ideal-render-target-product-details-important-info></ideal-render-target-product-details-important-info>
    </div>
    @if (componentWidth() > ComponentLayoutSize.Large) {
      <div long-description *ifHasRenderInSources="LayoutComponents[LayoutTargets.LongDescription]">
        <ideal-render-target-product-details-long-description></ideal-render-target-product-details-long-description>
      </div>
    }
    <div info *ifHasRenderInSources="LayoutComponents[LayoutTargets.Info]">
      <ideal-render-target-product-details-info></ideal-render-target-product-details-info>
    </div>
    <div separator></div>
    <div badges *ifHasRenderInSources="LayoutComponents[LayoutTargets.Badges]">
      <ideal-render-target-product-details-badges></ideal-render-target-product-details-badges>
    </div>
  </div>
  @if (componentWidth() <= ComponentLayoutSize.Medium) {
    <div actions>
      <ideal-render-target-product-details-actions></ideal-render-target-product-details-actions>
    </div>
  }
  @if (componentWidth() > ComponentLayoutSize.Medium) {
    <div side-col>
      <div side-col-sticky>
        <div actions-container>
          <div title>
            <ideal-render-target-product-details-title></ideal-render-target-product-details-title>
          </div>
          <div actions>
            <ideal-render-target-product-details-actions></ideal-render-target-product-details-actions>
          </div>
        </div>
        <div extra-actions-container>
          <ideal-render-target-product-details-extra-actions extra-actions></ideal-render-target-product-details-extra-actions>
        </div>
        <! -- <div vendor-container>Vendor</div> - ->
      </div>
    </div>
  }

  <div default>
    @if (componentWidth() <= ComponentLayoutSize.Medium) {
      <div extra-actions-container>
        <ideal-render-target-product-details-extra-actions extra-actions></ideal-render-target-product-details-extra-actions>
      </div>
    }
    @if (componentWidth() <= ComponentLayoutSize.Large) {
      <ideal-product-section
        *ifHasRenderInSources="LayoutComponents[LayoutTargets.LongDescription]"
        long-description
        i18n-title="@@products.longDescription.label"
        title="Description"
        navAnchorId="app.main-menu/products/details/description"
        navAnchorHeading="Product"
        i18n-navAnchorHeading="@@products.nav.product.heading"
        [navAnchorHidden]="!ready()"
        class="padded"
      >
        <ideal-render-target-product-details-long-description></ideal-render-target-product-details-long-description>
      </ideal-product-section>
    }

    <ideal-render-target-product-details-default></ideal-render-target-product-details-default>
  </div>
</div>
<div footer *ifHasRenderInSources="LayoutComponents[LayoutTargets.Footer]">
  <ideal-render-target-product-details-footer></ideal-render-target-product-details-footer>
</div>

@if (typeComponentInjector() && productTypeComponents()) {
  <div style="display: none">
    @for (component of productTypeComponents(); track $index) {
      <ng-container *ngComponentOutlet="component; injector: typeComponentInjector(); inputs: componentInputs()"></ng-container>
    }
  </div>
} -->
